<template>
    <div 
        class="o-movie-hero-block"
        :style="commonStyles"
    >
        <div class="movie-hero-block-container">
            <div class="movie-details-smooth-layer" />
            <div class="movie-hero-block-poster">
                <img
                    :src="coverUrl || posterUrl"
                    :class="[
                        'movie-hero-block-poster-image',
                        {
                            'movie-hero-block-poster-image--blur': !coverUrl
                        }
                    ]"
                >
            </div>
            <div class="movie-hero-block-details">
                <div class="movie-hero-block-cover">
                    <img
                        :src="posterUrl"
                        class="movie-hero-block-cover-image"
                    >
                </div>
                <div class="movie-hero-block-extras">
                    <span class="movie-hero-block-title">
                        {{ title }}
                    </span>
                    <span class="movie-hero-block-genres">
                        {{ genres }}
                    </span>
                    <span class="movie-hero-block-rating">
                        {{ duration }} | {{ rating }}
                    </span>
                </div>
                <div class="movie-hero-block-button-container">
                    <AButton
                        theme="dark"
                        :text="$t('o-movie-schedule.tickets')"
                        class="movie-hero-block-button-button"
                        @onClick="onClick"
                    />
                </div>
            </div>
        </div>
        <div class="movie-hero-block-description">
            <p class="movie-hero-block-text">
                {{ description }}
            </p>
            <OMovieDescriptionBlock
                v-if="originalTitle"
                :label="`${$t('o-movie-schedule.original-title')}:`"
                :text="originalTitle"
            />
            <OMovieDescriptionBlock
                v-if="originalLanguage"
                :label="`${$t('o-movie-schedule.original-language')}:`"
                :text="originalLanguage"
            />
            <OMovieDescriptionBlock
                v-if="premier"
                :label="`${$t('o-movie-schedule.premiere')}:`"
                :text="premier"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AButton from '../../atoms/a-button/a-button';
import OMovieDescriptionBlock from '../../organisms/o-movie-description-block';

export default {
    name: 'OMovieHeroBlock',
    components: {
        AButton,
        OMovieDescriptionBlock
    },
    props: {
        posterUrl: {
            type: String,
            default: ''
        },
        coverUrl: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        genres: {
            type: String,
            default: ''
        },
        duration: {
            type: String,
            default: ''
        },
        rating: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: ''
        },
        premier: {
            type: String,
            default: ''
        },
        originalTitle: {
            type: String,
            default: ''
        },
        originalLanguage: {
            type: String,
            default: ''
        }
    },
    methods: {
        onClick(e) {
            this.$emit('onCLick', e);
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        commonStyles() {
            return this.getMapConfigProp('components.OMovieHeroBlock.styles');
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
